import styled from 'styled-components'

import { Skeleton } from '@blade/ui-kit'

export const TradingAuditListSkeleton: React.FC = () => {
  return (
    <Root>
      <Row>
        <Skeleton height={7} width="100px" />
        <Skeleton height={7} width="50px" />
      </Row>
      <Row>
        <Skeleton height={7} width="100px" />
        <Skeleton height={7} width="50px" />
      </Row>
      <Row>
        <Skeleton height={7} width="100px" />
        <Skeleton height={7} width="50px" />
      </Row>
      <Row>
        <Skeleton height={7} width="100px" />
        <Skeleton height={7} width="50px" />
      </Row>
    </Root>
  )
}

const Root = styled.div`
  border: 1px solid var(--background-3);
  background: var(--background-2);

  display: grid;
  border-radius: 12px;
  padding: 1px;
  gap: 2px;

  padding: 15px 10px;
`

const Row = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  align-items: center;
  justify-content: space-between;

  &:not(:last-child)::after {
    content: '';
    grid-column: 1/-1;
    height: 1px;
    width: 100%;
    opacity: 0.1;

    background-image: radial-gradient(
      circle at center,
      var(--background-12) 0%,
      transparent 100%
    );

    margin: 15px 0;
  }
`
